export const load = () => ({
	title: '7 Ways to Soundproof Your Apartment or Condo',
	showTitle: true,
});
